module.exports = __webpack_public_path__ + "img/beg.452c0b09.png";